import getHtmlParam from '../../utilities/htmlParam';
import * as traversal from '../../utilities/traversal';
import { Search } from './search';
import { SearchRating } from './search-rating';
import { SearchFilter } from './filter';
import { isMobile } from '../../utilities/user-agent';
import {getURLParams, openFilterByOpenedFilterFromSession} from '../../utilities/helpers';
import { productColors as initProductColors } from '../global/splide';
import { StickyMobileFilter } from './sticky';
import { initWishlist, onClickWishlistonPues } from './towishlist';
import { addToComparison, initComparison, initComparisonSidebar } from './comparison';
import { updateAdvisorStep } from './advisor';
import {addEnterAndSpaceHandler, removeEnterAndSpaceHandler} from "@utils/accessibility/general";

declare let _satellite: any;
const mp = getHtmlParam('.js-mp .param');
const search = new Search();
let param = getHtmlParam('.js-param .param');

export class Pues {

  loadMoreBtn = document.getElementById('loadmore') as HTMLButtonElement;
  loadPrevBtn = document.getElementById('loadprev') as HTMLButtonElement;
  resultCount = document.querySelectorAll('.query-result-count');
  productsWrapper = document.querySelector('.product-list-wrapper');
  visibleProducts = 36;
  latestPage = param.get('curPage');
  nextPage = param.get('nextPage');
  prevPage = '';
  numPages = param.get('numPages');
  curPage = param.get('curPage');
  isIE11 = document.body.parentElement.classList.contains('no-webp');
  filterChanged = false;
  openFilters: string[] = [];

  start() {
    const filterSort = document.querySelectorAll('.filter-sort');
    const layoutToggles = document.querySelectorAll('.toggle-layout');

    filterSort.forEach(filter => {
      filter.addEventListener('click', () => {
        const filterValue = filter.getAttribute('data-value');
        const filterDirection = filter.getAttribute('data-direction');
        const filterName = filter.textContent;
        const hiddenFilterSorting = document.getElementById('hiddenFilter-sorting');
        const hiddenFilterDirection = document.getElementById('hiddenFilter-direction');
        const filterForm = document.getElementById('filter-form') as HTMLFormElement;
        document.querySelector('.sort-pageLimits .uline').textContent = filterName;
        filter.parentElement.querySelectorAll('.filter-sort').forEach(li => li.classList.remove('active'));
        filter.classList.add('active');
        hiddenFilterSorting && ((hiddenFilterSorting as HTMLInputElement).value = filterValue);
        hiddenFilterDirection && ((hiddenFilterDirection as HTMLInputElement).value = filterDirection);
        filterForm && this.filterProducts(filterForm, '1');
      });
    });

    layoutToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const filterValue = toggle.getAttribute('data-value');
        const tempParams = new URLSearchParams(window.location.search);
        tempParams.set('layout', filterValue);
        const newUrl = location.protocol + '//' + location.host + location.pathname + '?' + tempParams.toString();
        window.location.href = newUrl;
      });
    });

    this.loadMoreBtn && this.loadMoreBtn.addEventListener('click', () => {
      !this.nextPage && (this.nextPage = param.get('nextPage'));
      const filterForm = document.getElementById('filter-form') as HTMLFormElement;
      filterForm && this.filterProducts(filterForm, this.nextPage);
    });

    this.loadPrevBtn && this.loadPrevBtn.addEventListener('click', () => {
      const filterForm = document.getElementById('filter-form') as HTMLFormElement;
      filterForm && this.filterProducts(filterForm, this.prevPage, true);
    });

    if (this.numPages === '1' || this.numPages === this.curPage) {
      this.loadMoreBtn && (this.loadMoreBtn.style.display = 'none');
    }

    this.productsWrapper && this.productsWrapper.parentElement.addEventListener('click', (el) => {
      let product: HTMLElement;
      const productGridItem = (el.target as HTMLElement).closest('.product-element') as HTMLElement;
      const productListItem = (el.target as HTMLElement).closest('.pues-list-item') as HTMLElement;
      if (productGridItem || productListItem) {
        product = productGridItem || productListItem;
        let page: HTMLElement;
        if (product.hasAttribute('data-page')) {
          page = product;
        } else {
          page = search.getPreviousSibling(product, 'div[data-page]') as HTMLElement;
        }
        const tempParams = new URLSearchParams(window.location.search);
        tempParams.set('page', page ? page.dataset.page : '1');
        const newUrl = location.protocol + '//' + location.host + location.pathname + '?' + tempParams.toString();
        history.pushState({urls: newUrl}, '', newUrl);
        if (product) sessionStorage.productPos = product.id;
      }
    });
    if (window.innerWidth <= 992) {
      let stickyFilter = new StickyMobileFilter();
      stickyFilter.init();
    }

    initWishlist();

    const resultsWrap = document.querySelector('.product-list-wrapper');
    resultsWrap && resultsWrap.parentElement.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).closest('.wishlist-cta')) {
        e.preventDefault();
        onClickWishlistonPues(e.target as Element);
      }
      if ((e.target as HTMLElement).closest('.add-to-compare')) {
        addToComparison(e.target as Element);
      }
      if ((e.target as HTMLElement).closest('.added-to-compare')) {
        addToComparison(e.target as Element);
      }
    });

    this.handleHistory();

    initComparisonSidebar();
    initComparison();
  }

  init() {
    window.removeEventListener('resize', this.widgetOrder, false);

    const filterCategoryToggle = document.querySelectorAll('.filter-category-toggle, .category-wrapper-close');
    const filterToggle :NodeListOf<HTMLElement> = document.querySelectorAll('.filter-toggle, .filter-wrapper-close');
    const toggleFilterChecks = document.querySelectorAll('.js-toggle-filter-check input');
    const toggleRemoveFilters = document.querySelectorAll('.js-toggle-remove-filter');
    const filterHeadlines :NodeListOf<HTMLElement> = document.querySelectorAll('.filter .filterHeadline');
    const removeAllFilter = document.querySelector('.toggle-remove-all-filter');
    const filterClose = document.querySelectorAll('.filter-close');
    const filterForm = document.getElementById('filter-form') as HTMLFormElement;
    const filterCategories = document.querySelectorAll('.filter-categories a.active');
    const filterSearch = document.querySelectorAll('.filter-search');
    const topBrands = document.querySelectorAll('.results-brand > span');
    const filterItemHolder = document.querySelector('.filter-form-items');
    const showAllFilter = document.querySelectorAll('.filter-wrapper .back-to-filters');
    const mobileFilterSubmit = document.querySelector('.mobile-filter-submit');
    const mobileFilterControls :HTMLElement | null = document.querySelector('.mobile-filter-controls');
    const showAllItemsOfFilterBtns:NodeListOf<HTMLDivElement> = document.querySelectorAll('.js-show-all-items-of-filter');

    initProductColors();
    this.initArticleColors();

    openFilterByOpenedFilterFromSession();

    filterCategories.forEach((link) => {
      traversal.parents(link, 'ul').forEach(list => {
        list.classList.add('active');
        traversal.siblings(list, 'a').forEach(anker => anker.classList.add('hassub-active'));
      });
    });

    filterCategoryToggle.forEach(toggle => {
      if(!toggle.classList.contains('addedClickEvent')) {
        toggle.addEventListener('click', () => {
          const filterCategoryWrapper = document.querySelector('.filter-category-wrapper') as HTMLElement;
          if (filterCategoryWrapper?.querySelector('div').offsetParent === null) {
            filterCategoryWrapper.style.display = 'block';
            const firstLink :HTMLElement | null = filterCategoryWrapper?.querySelector('a');
            firstLink?.focus();
          } else {
            filterCategoryWrapper.style.display = 'none';
          }
        });
        toggle.classList.add('addedClickEvent');
      }
    });

    filterToggle.forEach(toggle => {
      if(!toggle.classList.contains('addedClickEvent')) {
        toggle.addEventListener('click', () => {
          if (filterToggle[0].classList.contains('active')) {
            filterToggle[0].classList.remove('active');
          } else {
            filterToggle[0].classList.add('active');
          }
          const filterFormWrapper :HTMLElement | null = document.querySelector('.filter-form-wrapper');
          const form:HTMLFormElement | null = filterFormWrapper.querySelector('form');

          if(filterFormWrapper) {
            if (form && form.offsetParent === null) {
              filterFormWrapper.style.display = 'block';
              if (isMobile.screenSize() && mobileFilterControls) {
                mobileFilterControls.style.display = 'flex';
                const firstFilter :HTMLElement | null = filterFormWrapper.querySelector('.acc-header');
                firstFilter?.focus();
              }
            } else {
              filterFormWrapper.style.display = 'none';
              if (isMobile.screenSize() && mobileFilterControls) {
                mobileFilterControls.style.display = 'none';
              }
            }
          }
        });
        toggle.classList.add('addedClickEvent');
      }
    });
    const filterFormWrapper :HTMLElement | null = document.querySelector('.filter-form-wrapper');
    const categoryFilterWrapper :HTMLElement | null = document.querySelector('.filter-category-wrapper');

    filterFormWrapper?.removeEventListener('keydown', this.closeFilterOnEscape);
    filterFormWrapper?.addEventListener('keydown', this.closeFilterOnEscape);

    categoryFilterWrapper?.removeEventListener('keydown', this.closeCategoryFilterOnEscape);
    categoryFilterWrapper?.addEventListener('keydown', this.closeCategoryFilterOnEscape);


    toggleFilterChecks.forEach((filter: HTMLInputElement, index) => {
      filter.addEventListener('change', () => {
        if (filter.name === 'filter-range.deliveryTime') {
          toggleFilterChecks.forEach((filter: HTMLInputElement, deliveryTimeIndex) => {
            if (filter.name === 'filter-range.deliveryTime' && index !== deliveryTimeIndex) {
              filter.checked = false
            }
          });
        };
        if (isMobile.any()) {
          this.filterChanged = true;
          this.filterChanged && this.updateFilters(filterForm);
          return false;
        }
        this.filterProducts(filter.closest('form'), '1');
      });
    });

    mobileFilterSubmit && mobileFilterSubmit.addEventListener('click', () => {
      this.filterProducts(filterItemHolder.closest('form'), '1');
    });

    toggleRemoveFilters.forEach((filter: HTMLElement) => {
      filter.addEventListener('click', () => {
        const advisorCompleted = document.querySelector('.advisor-completed') as HTMLElement;
        advisorCompleted && (advisorCompleted.style.display = 'none');
        const formRemoveFilter = document.getElementById('form-remove-filter') as HTMLFormElement;
        formRemoveFilter && this.filterProducts(formRemoveFilter, '1');
      });
    });

    filterHeadlines.forEach(headline => {
      if(!headline.classList.contains('addedClickEvent')) {
        headline.addEventListener('click', () => {
          if (headline.classList.contains('active')) {
            headline.classList.remove('active');
            this.openFilters = this.openFilters.filter(item => item !== headline.innerText);
          } else {
            headline.classList.add('active');
            this.openFilters.push(headline.innerText)

            const priceFilterWrapper = headline.parentNode.querySelector('.filter-range-input-wrapper')
            if(priceFilterWrapper) {
              const minPrice :HTMLInputElement = priceFilterWrapper.querySelector('[data-filter-type=min]')
              const maxPrice :HTMLInputElement = priceFilterWrapper.querySelector('[data-filter-type=max]')

              if(minPrice && minPrice.value === '') {
                minPrice.value = minPrice.min
              }
              if(maxPrice && maxPrice.value === '') {
                maxPrice.value = maxPrice.max
              }
            }
          }
          sessionStorage.setItem('openFilters', JSON.stringify(this.openFilters));
        });
        headline.classList.add('addedClickEvent');
      }
    });

    removeAllFilter && removeAllFilter.addEventListener('click', () => {
      const filterSelectedLists = document.querySelectorAll('.filter-selected-list');
      filterSelectedLists.forEach(filter => filter.innerHTML = '' );
      const filterSelected = document.querySelectorAll('.filter-selected');
      filterSelected.forEach((filter: HTMLElement) => filter.style.display = 'none');
    });

    filterClose.forEach(filter => {
      filter.addEventListener('click', () => {
        filter.parentElement.style.display = 'block';
      });
    });

    filterForm && filterForm.addEventListener('keyup keypress', (e: KeyboardEvent) => {
        const keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
          e.preventDefault();
          return false;
        }
    });

    if (filterForm) {
      const filterFormButtons = filterForm.querySelectorAll('.range-submit');
      filterFormButtons.forEach((button: HTMLButtonElement) => {
        button.addEventListener('click', () => {
          const priceInputs = button.closest('.filter-range-input-wrapper').querySelectorAll('.filter-range-input');
          const filterRangeNumber = document.querySelectorAll('.filter-range-number')
          const priceMin = parseInt((priceInputs[0] as HTMLInputElement).value);
          const priceMax = parseInt((priceInputs[1] as HTMLInputElement).value);

          if (priceInputs[0] && ((priceInputs[0] as HTMLInputElement).value === ''
              && (priceInputs[1] as HTMLInputElement).value === '')) {
            return false;
          }

          if (priceMax <= priceMin) {
            filterRangeNumber[0].classList.add('price-form-field-error');
            filterRangeNumber[1].classList.add('price-form-field-error');
            return false;
          }

          this.filterProducts(filterForm);
        });
      });
    }

    filterSearch.forEach((search:HTMLInputElement)=>{
      search.addEventListener('keyup', (event) => {
        const searchstring = search.value;
        if (searchstring !== '') {
          search.closest('.acc-content').querySelectorAll('.filter-categories > ul > li').forEach((item: HTMLElement) => {
            item.style.display = 'none';
            const value = (item.querySelector('.js-toggle-filter-check input') as HTMLInputElement).value;
            if (value.toLowerCase().indexOf(searchstring.toLowerCase()) >= 0) {
              item.style.display = 'block';
            }
          });
        } else {
          search.closest('.acc-content').querySelectorAll('.filter-categories > ul > li').forEach((item: HTMLElement) => item.style.display = 'block');
        }
      });
    });

    // if category desc
    if (param.get('categoryDescription') === 'true') {
      const showChar = 400;
      const ellipsestext = '...';
      const truncates = document.querySelectorAll('.truncate');

      truncates.forEach((truncate, i) => {
        const content = truncate.innerHTML;

        if (content.length > showChar) {
          const c = content.substr(0, showChar);
          const h = content;
          const html =
              '<div class="truncate-text" style="display:block">' +
              c +
              '<span class="moreellipses">' +
              ellipsestext +
              '&nbsp;&nbsp;<a href="" class="moreless more">' + mp.get('modal_more') + '</a></span></span></div><div class="truncate-text" style="display:none">' +
              h +
              '<a href="" class="moreless less">' + mp.get('modal_less') + '</a></span></div>';
          truncate.innerHTML = html;
        }
        if (truncates.length - 1 === i) {
          moreLess();
        }
      });

      param = getHtmlParam('.js-param .param');
    }

    topBrands.forEach((brand: HTMLElement) => {
      brand.addEventListener('click', () => {
        const filterForm = document.getElementById('filter-form') as HTMLFormElement;
        const brandName = brand.dataset.brand;
        const brandCheckbox = filterForm.querySelector('input[value="' + brandName + '"]') as HTMLInputElement;
        brandCheckbox && (brandCheckbox.checked = true);
        filterForm && this.filterProducts(filterForm, '1');
      });
    });

    function moreLess() {
      const morelessToggle = document.querySelectorAll('.moreless');
      morelessToggle.forEach(link => {
        link.addEventListener('click', () => {
          event.preventDefault();
          const cT = link.closest('.truncate-text');

          if (link.classList.contains('less')) {
            if ((cT.previousElementSibling as HTMLElement).offsetParent === null) {
              (cT.previousElementSibling as HTMLElement).style.display = 'block';
            } else {
              (cT.previousElementSibling as HTMLElement).style.display = 'none';
            }
          } else {
            if ((cT.nextElementSibling as HTMLElement).offsetParent === null) {
              (cT.nextElementSibling as HTMLElement).style.display = 'block';
            } else {
              (cT.nextElementSibling as HTMLElement).style.display = 'none';
            }
          }
          if ((cT as HTMLElement).offsetParent === null) {
            (cT as HTMLElement).style.display = 'block';
          } else {
            (cT as HTMLElement).style.display = 'none';
          }
        });
      });
    }

    // if search query
    if (param.get('isQueryEscaped')) {
      window.fetch(param.get('baseUrl') + '/product/search/category-suggest?query=' + param.get('queryUrlEncoded'))
          .then(res => res.json())
          .then((data) => {
              let html = '<ul>';
              let hasContent = false;
              data.forEach((item: any) => {
                hasContent = true;

                let highlighted = item.categoryName;
                highlighted = highlighted.replace(/(' + param.get('queryEscaped') + ')/gi, '<strong>$1</strong>');

                const line = '<li><a href=\"' + item.categoryUrl + '\" aria-label=\"suggestion\">' + highlighted + '</a></li>';
                html += line;
              });
              html += '</ul>';

              const suggestionsContent = document.getElementById('category-suggestions-content');
              const categorySuggestions = document.getElementById('category-suggestions');
              suggestionsContent && (suggestionsContent.innerHTML = html);
              if (hasContent) {
                categorySuggestions && ((categorySuggestions as HTMLElement).style.display = 'block');
              }

          }).catch(err => {
            console.log(err);
          });
    }

    const multiWidget = document.querySelectorAll('.product-list-wrapper .widget-multicolumn');

    if (multiWidget) {
      // store row for banner for repositioning on resize
      const children = document.querySelectorAll('.product-list-wrapper > div');
      multiWidget.forEach((widget: HTMLElement, index) => {
        const position = Array.prototype.slice.call(children).indexOf(widget) || 0;
        widget.dataset.row = ((position - index) / 4).toString();
      });
      this.widgetOrder();
      window.addEventListener('resize', this.widgetOrder, false);
    }

    const searchQueryString = document.getElementById('searchQueryString') as HTMLInputElement;
    const queryString = searchQueryString && searchQueryString.value;
    if (typeof queryString !== 'undefined') {
      const queryId = document.getElementById('query') as HTMLInputElement;
      queryId && (queryId.value = queryString);
    }

    if (!isMobile.screenSize()) {
      showAllItemsOfFilterBtns.forEach(btn => {
          const ul = btn.previousElementSibling;
          const lis = ul.querySelectorAll('li');
          lis.forEach(li => {
            li.classList.remove('hidden');
          });
      });
    }

    showAllItemsOfFilterBtns.forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const ul = btn.previousElementSibling;
        const lis = ul.querySelectorAll('li');

        if(btn.classList.contains('items-closed')) {
          lis.forEach(li => {
            li.classList.remove('hidden');
          });
          btn.classList.remove('items-closed')
          btn.innerText = 'Weniger anzeigen'
        } else {
          lis.forEach((li, index) => {
            if(index > 4) {
              li.classList.add('hidden');
            }
          });
          btn.classList.add('items-closed')
          btn.innerText = 'Alle anzeigen'
        }

      });
    });

  }

  // reorder banner depending on screen resolution (grid size)
  widgetOrder() {
    const multiWidget = document.querySelectorAll('.product-list-wrapper .widget-multicolumn');
    const mediaPues3Col = window.matchMedia('(min-width: 768px) and (max-width: 1279px)');
    let itemsPerRow = 4;
    mediaPues3Col.matches && (itemsPerRow = 3);
    multiWidget.forEach((widget: HTMLElement) => {
      const row = widget.dataset.row;
      if (row) {
        const newpos = parseInt(row) * itemsPerRow - 1;
        const product = document.querySelectorAll('.product-list-wrapper > .product-element')[newpos];
        product && product.insertAdjacentElement('afterend', widget);
      }
    });
  }

  filterProducts(form: HTMLFormElement, page?: string, prevPage = false, advisor = false, brand = '') {
    page && search.applyPage(form, page);

    search.applySelectedFilters(form);
    const dataStringQuery = !brand ? search.serialize(form) : brand;
    const catId = param.get('categoryId');
    const searchTerm = param.get('queryEscaped') || '';
    this.productsWrapper = document.querySelector('.product-list-wrapper');
    const filterWrapper = document.querySelector('.filter-wrapper') as HTMLElement;
    const ratingContainer = document.querySelector('.row.rating-container');
    const activeFilterContainer = document.querySelector('.active-filter-container') as HTMLElement;
    if (page === '1' && !prevPage || !page) {
      filterWrapper.style.opacity = '.5';
      filterWrapper.style.pointerEvents = 'none';
      activeFilterContainer.style.opacity = '.5';
      activeFilterContainer.style.pointerEvents = 'none';
      if (isMobile.any()) {
        const filterCategoryToggle: HTMLElement = filterWrapper.querySelector('.filter-category-toggle');
        (filterWrapper.querySelector('.filter-form-wrapper') as HTMLElement).style.opacity = '0';
        (filterWrapper.querySelector('.mobile-filter-controls') as HTMLElement).style.opacity = '0';
        filterCategoryToggle && (filterCategoryToggle.style.opacity = '1');
        (filterWrapper.querySelector('.filter-toggle') as HTMLElement).style.opacity = '1';
      }
    } else {
      this.loadMoreBtn.disabled = true;
      this.loadPrevBtn.disabled = true;
    }
    (async() => {
      const loading :HTMLElement = document.querySelector('.loading-background');
      if(loading) {
        loading.style.display = 'block';
      }
      await search.updateResult(catId, searchTerm, dataStringQuery)
      .then((data: NodeList | any) => {
        // update url after filter
        const newUrl = location.protocol + '//' + location.host + location.pathname + '?' + dataStringQuery.replace('%3F', '&');
        history.pushState({urls: newUrl}, '', newUrl);

        let layout = 'grid';
        const products = data.querySelector('.product-list-wrapper');
        const filters = data.querySelector('.filter-wrapper');
        if (!products) return false;
        let productElements = products.querySelectorAll('.product-element');
        if (!productElements[0]) {
          productElements = products.querySelectorAll('.pues-list-item');
          layout = 'list';
          disabledFeatureHint(productElements);
        }
        let currentProductCount = this.productsWrapper.querySelectorAll('.product-element');
        !currentProductCount[0] && (currentProductCount = this.productsWrapper.querySelectorAll('.pues-list-item'));
        const getNewCurPage = data.querySelectorAll('[data-param-id="curPage"]')[0];
        const getPuesRating = data.querySelector('.rating-container');
        const getActiveFilters = data.querySelector('.active-filter-container');
        const productSorting = document.querySelector('.product-sorting') as HTMLElement;
        const getAdvisorCampaign = data.querySelector('.result-assistent');
        this.curPage = (getNewCurPage && getNewCurPage.textContent);
        const puesType = param.get('puesType');
        let trackName = '';
        if (puesType === 'BRAND_PUES') {
          trackName = 'brand';
        }
        if (puesType === 'SEARCH_PUES') {
          trackName = 'ses';
        }
        if (puesType === 'CATEGORY_PUES') {
          trackName = 'pus';
        }

        if (page === '1' && !prevPage || !page) {
          // on filter replace products
          if (typeof _satellite !== 'undefined' && _satellite && trackName) {
            trackName !== '' && _satellite.track(trackName + '_ajaxfilter');
          }
          this.visibleProducts = productElements.length;
          const parentWrapper = products && this.productsWrapper.parentElement;
          parentWrapper && parentWrapper.replaceChild(products, this.productsWrapper);
          this.latestPage = this.curPage;
          if (getPuesRating && ratingContainer) {
            ratingContainer?.parentElement?.replaceChild(getPuesRating, ratingContainer);
            new SearchRating().init();
          }
          if (getActiveFilters && activeFilterContainer) {
            activeFilterContainer?.parentElement?.replaceChild(getActiveFilters, activeFilterContainer);
          }
          let scrollTarget = document.querySelector('.product-sorting');
          if (document.querySelector('.result-assistent')) {
            scrollTarget = document.querySelector('.result-assistent');
          }
          const topbar = document.getElementById('header-topbar');
          let yOffset = -65;
          window.innerWidth <= 1440 && (yOffset = -110);
          topbar && (yOffset = yOffset - topbar.offsetHeight);
          const y = scrollTarget.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        } else {
          // on load more append products
          if (typeof _satellite !== 'undefined' && _satellite && trackName && getNewCurPage) {
            trackName !== '' && _satellite.track(trackName + '_ajaxcall', { pageNumber: this.curPage } );
          }
          this.loadMoreBtn.disabled = false;
          this.loadPrevBtn.disabled = false;
          const items = Array.from(productElements) as HTMLElement[];

          productElements[0] && productElements[0].setAttribute('data-page', this.curPage);
          if (prevPage) {
            const newPrevPage = parseInt(this.curPage) - 1;
            this.prevPage = newPrevPage && newPrevPage.toString();
            if (products && this.isIE11) {
              for (let i = items.length - 1; i >= 0; i--) {
                this.productsWrapper.insertBefore(items[i], this.productsWrapper.children[0]);
              }
            }
            if (products && !this.isIE11) {
              this.productsWrapper.prepend(...items);
            }
          } else {
            if (products && this.isIE11) {
              for (let i = 0; i < items.length; i++) {
                this.productsWrapper.appendChild(items[i])
              }
            }
            if (products && !this.isIE11) {
              this.productsWrapper.append(...items);
            }
            this.latestPage = this.curPage;
          }
          this.visibleProducts = currentProductCount && (currentProductCount.length + productElements.length);
        }
        const parentFilter = filters && filterWrapper;
        parentFilter && parentFilter.parentElement?.replaceChild(filters, filterWrapper);
        const getNewParams = data.querySelectorAll('[data-param-id="nextPage"]')[0];
        const getNewNumPage = data.querySelectorAll('[data-param-id="numPages"]')[0];
        const getNewResultCount = data.querySelectorAll('[data-param-id="numResults"]')[0];
        const newParams = data.querySelector('.js-param');
        const jsParams = document.querySelector('.js-param');
        const productCount = document.querySelector('.products-visible');
        if (newParams && jsParams) {
          jsParams.parentElement.replaceChild(newParams, jsParams);
        }
        this.resultCount.forEach((count) => {
          count.textContent = getNewResultCount?.textContent + ' ' + mp?.get('search_result');
        });
        productCount && (productCount.textContent = this.visibleProducts.toString());
        getNewParams && !prevPage && (this.nextPage = getNewParams.textContent);
        getNewNumPage && (this.numPages = getNewNumPage.textContent);

        // hide Load More if last page
        if (this.latestPage === this.numPages || this.curPage === this.numPages) {
          this.loadMoreBtn && (this.loadMoreBtn.style.display = 'none');
        } else {
          this.loadMoreBtn && (this.loadMoreBtn.style.display = 'inline-block');
        }

        // hide Load Prev if first page
        if (newParams.outerHTML.indexOf('curPage">1<') !== -1) {
          this.loadPrevBtn.parentElement.style.display = 'none';
        }

        // on TiTo updates
        if (brand) {
          const productCountPagination = document.querySelector('.products-shown') as HTMLElement;
          productCountPagination && (productCountPagination.parentElement.style.display = 'block');
          !productElements.length && (document.querySelector('.product-list-wrapper').innerHTML = '<span class="no-result">' + mp.get('no_results') + '</span>');
        }

        productSorting.style.display = 'block';

        // update advisor campaign
        const advisorContainer = document.querySelector('.result-assistent') as HTMLElement;
        if (getAdvisorCampaign) {
          updateAdvisorStep(getAdvisorCampaign);
        } else {
          advisorContainer && (advisorContainer.style.display = 'none');
        }

        // re-init selectors
        new SearchFilter().init();
        new SearchFilter().activeFilter();
        this.init();
        if(window.innerWidth <= 992) {
          let stickyFilter = new StickyMobileFilter();
          stickyFilter.init();
        }
        param = getHtmlParam('.js-param .param');
        if(loading) {
          loading.style.display = 'none';
        }
        removeEnterAndSpaceHandler();
      })
        .then((data: NodeList | any) => {
          addEnterAndSpaceHandler();
        });
    })();
  }

  updateFilters(form: HTMLFormElement) {
    search.applySelectedFilters(form);
    const dataStringQuery = search.serialize(form);
    const catId = param.get('categoryId');
    const searchTerm = param.get('queryEscaped');
    const filterWrapper = document.querySelector('.filter-wrapper') as HTMLElement;
    const filterFormWrapper = filterWrapper.querySelector('.filter-form-wrapper') as HTMLElement;
    const mobileFilterControls :HTMLElement | null = document.querySelector('.mobile-filter-controls');
    if(mobileFilterControls) mobileFilterControls.style.pointerEvents = 'none';

    search.updateResult(catId, searchTerm, dataStringQuery, true).then((data: NodeList | any) => {
      const filters = data.querySelector('.filter-wrapper');
      if (filters) {
        const count = data.querySelector('[data-count]');
        data.querySelector('.filter-form-wrapper').style.display = 'block';
        data.querySelector('.mobile-filter-controls').style.display = 'flex';
        data.querySelector('.js-remove-filter-btn')?.removeAttribute('disabled');
        openFilterByOpenedFilterFromSession();

        filterFormWrapper.style.pointerEvents = 'none';

        filterWrapper && filterWrapper.parentElement?.replaceChild(filters, filterWrapper);
        const resultPreview = document.querySelector('.result-preview-count') as HTMLElement;
        count && resultPreview && (resultPreview.innerText = count.dataset.count + ' ');



        filterFormWrapper.removeEventListener('keydown', this.closeFilterOnEscape);
        const firstFilter :HTMLElement | null = document.querySelector('.acc-header');
        firstFilter?.focus();

        filterFormWrapper.addEventListener('keydown', this.closeFilterOnEscape);

        removeEnterAndSpaceHandler();
        addEnterAndSpaceHandler();

        this.init();
        new SearchFilter().init();
      }
    });
  }

  closeFilterOnEscape(event :KeyboardEvent) {

    if(document.activeElement.closest('.filter-form-wrapper')) {
      if(event.key === 'Escape') {
        const filterToggle :HTMLElement | null = document.querySelector('.filter-toggle');
        const filterWrapperClose :HTMLElement | null = document.querySelector('.filter-wrapper-close');
        filterWrapperClose?.click();
        filterToggle?.focus();
      }
    }
  }
  closeCategoryFilterOnEscape(event :KeyboardEvent) {

    if(document.activeElement.closest('.filter-category-wrapper')) {
      if(event.key === 'Escape') {
        const categoryFilterToggle :HTMLElement | null = document.querySelector('.filter-category-toggle');
        const categoryFilterWrapperClose :HTMLElement | null = document.querySelector('.category-wrapper-close');

        categoryFilterWrapperClose?.click();
        categoryFilterToggle?.focus();
      }
    }
  }

  handleHistory() {
    window.addEventListener('popstate', (e) => {
      window.history.go(0);
      e.preventDefault();
    });

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    const paramUrl = getURLParams();

    if ('productPos' in sessionStorage && paramUrl.page) {
      setTimeout(() => {
        const productPos = document.getElementById(sessionStorage.productPos);
        const yOffset = -100;
        if (productPos) {
          const y = productPos.getBoundingClientRect().top + window.pageYOffset + yOffset;
          if (this.isIE11) {
            document.documentElement.scrollTop = y;
          } else {
            window.scrollTo({top: y, behavior: 'smooth'});
          }
        }
        sessionStorage.removeItem('productPos');
      }, 100);
    }

    if (!this.productsWrapper) return;

    let currentProductCount = this.productsWrapper.querySelectorAll('.product-element');
    !currentProductCount[0] && (currentProductCount = this.productsWrapper.querySelectorAll('.pues-list-item'));
    this.visibleProducts = (currentProductCount && currentProductCount.length);

    const productCount = document.querySelector('.products-visible');
    productCount && (productCount.textContent = this.visibleProducts.toString());

    if (paramUrl.page && paramUrl.page !== '1') {
      const prevPageNum = parseInt(paramUrl.page) - 1;
      this.prevPage = prevPageNum.toString();
      this.loadPrevBtn.parentElement.style.display = 'block';
      currentProductCount[0] && currentProductCount[0].setAttribute('data-page', paramUrl.page)
    }

    this.productsWrapper.parentElement.addEventListener('click', (el) => {
      const product = (el.target as HTMLElement).closest('.product-element') as HTMLElement;
      if (product) {
        let page: HTMLElement;
        if (product.hasAttribute('data-page')) {
          page = product;
        } else {
          page = search.getPreviousSibling(product, '.product-element[data-page]') as HTMLElement;
        }
        const tempParams = new URLSearchParams(window.location.search);
        tempParams.set('page', page ? page.dataset.page : '1');
        const newUrl = location.protocol + '//' + location.host + location.pathname + '?' + tempParams.toString();
        history.pushState({urls: newUrl}, '', newUrl);
        if (product) sessionStorage.productPos = product.id;
      }
    });
  }

  initArticleColors() {
    const articleColors = document.querySelectorAll('.article-color-set');
    articleColors.forEach((color: HTMLElement) => {
      color.addEventListener('mouseenter', () => {
        search.loadArticleDetails(color.dataset.productid, color.dataset.articleid, color.dataset.articlecolorimage, color.dataset.url);
      });
      color.addEventListener('focus', () => {
        search.loadArticleDetails(color.dataset.productid, color.dataset.articleid, color.dataset.articlecolorimage, color.dataset.url);
      });
      if(param.get('tenant') === 'ssh_at') {
        color.addEventListener('click', () => {
          window.location.href = color.dataset.url;
        });
      }
    });
  }
}

export function resetPriceRange() {
  const filterForm = document.getElementById('filter-form') as HTMLFormElement;
  const customPrice = document.querySelectorAll('.filter-range-input');
  customPrice.forEach((input: HTMLInputElement) => input.value = '' );

  filterForm && new Pues().filterProducts(filterForm, '1');
}

export function resetDeliveryTime() {
  const filterForm = document.getElementById('filter-form') as HTMLFormElement;
  const deliveryTimeCategory = document.querySelectorAll('[name="filter-range.deliveryTime"]');
  deliveryTimeCategory.forEach((input: HTMLInputElement) => input.checked = false );

  filterForm && new Pues().filterProducts(filterForm, '1');
}

export function resetSelectedFilter(activeFilter :HTMLElement) {
  const filterForm = document.getElementById('filter-form') as HTMLFormElement;
  activeFilter?.removeAttribute('checked');
  filterForm && new Pues().filterProducts(filterForm, '1');
}

export function disabledFeatureHint(products: NodeList) {
  products.forEach((product: HTMLElement) => {
    const disabledFeatures = product.querySelectorAll('.feature-toggle-disabled');
    disabledFeatures.forEach((feature: HTMLElement) => {
      feature.addEventListener('mouseover', () => {
        const tooltipText = feature.closest('.feature-toggle-wrapper').querySelector('.feature-toggle-disabled-hint-text');
        if (tooltipText) {
          const hint = document.createElement('span');
          hint.classList.add('feature-toggle-disabled-hint');
          hint.innerHTML = tooltipText.textContent;
          feature.appendChild(hint);
        }
      });

      feature.addEventListener('mouseleave', () => {
        const disabledHint = feature.querySelector('.feature-toggle-disabled-hint');
        disabledHint && disabledHint.parentNode.removeChild(disabledHint);
      });
    });
  });
}
